







import Vue from 'vue'
import { mapActions, mapState } from 'vuex';


import TheNavigation from 'base/components/TheNavigation.vue'
import { SocketService } from 'base/services'
import CacheProcessorMessenger from './base/cache/CacheProcessorMessenger'
import CacheService from './base/cache/CacheService'
import { PullService } from './base/services/PullService'
import { ChatService } from './messenger/chat/ChatService'
import { StoreStateInterface } from 'base/store';

export default Vue.extend({
  name: 'App',
  components: {
    TheNavigation
  },
  data() {
    return {
      draggingEnterCounter: 0
    }
  },
  computed: {
    ...mapState({
      isInitialized: (state: StoreStateInterface | any) => state.app.initialized,
    }),
    isDashboardRoute() {
      return this.$route.name === 'dashboards'
    }
  },
  async mounted() {
    if (localStorage.getItem('ls.jwt') !== null)
      await this.setJWT(JSON.parse(localStorage.getItem('ls.jwt') || ''));
    // Load data from API if state is not cached in localStorage
    if (!this.isInitialized) await this.getAllPullData().then(() => this.setAppInitialized(true));

    ChatService.watchMessageCache()

    await PullService.start()

    const socketService = new SocketService()
    socketService.connect()

    // Prevent default drag & drop behaviour, as possible events are handled in app
    window.addEventListener('dragover', event => event.preventDefault())
    window.addEventListener('drop', event => event.preventDefault())
    window.addEventListener('dragover', event => event.preventDefault())
    // Add '--dragover' class on drag over
    window.addEventListener('dragenter', () => this.draggingEnterCounter++)
    window.addEventListener('dragleave', () => this.draggingEnterCounter--)
    window.addEventListener('dragend', () => this.draggingEnterCounter = 0)
    window.addEventListener('drop', () => this.draggingEnterCounter = 0)
  },
  methods: {
    ...mapActions([
      'getAllPullData',
      'setJWT',
      'setAppInitialized',
    ]),
  }
})
